// import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
import HeaderLayout from '@/layouts/HeaderLayout';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV);

const frameIn = [
  {
    path: '/',
    name: 'defaultPage',
    redirect: {
      name: 'home',
    },
    component: HeaderLayout, //布局
    children: [
      {
        path: 'home',
        name: 'home',
        component: _import('home'),
        meta: {auth: false}
      },
      {
        path: 'contact',
        name: 'contact',
        component: _import('contact'),
        meta: {auth: false}
      },
      {
        path: 'support',
        name: 'support',
        component: _import('support'),
        meta: {auth: false}
      },
      {
        path: 'product',
        name: 'product',
        component: _import('product'),
        meta: {auth: false}
      },
      {
        path: 'about',
        name: 'about',
        component: _import('about'),
        meta: {auth: false}
      }
    ]
  },
];


/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/notFound'),
  },
];

/**
 * 在主框架之外显示
 */
const frameOut = [
  //待实现
];


// 重新组织后导出
export default [...frameIn, ...errorPage];



// WEBPACK FOOTER //
// ./src/router/routes.js